import React, { ReactNode } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Menu from "../menu";

interface IWrapperProps {
  children: ReactNode;
}

export default function Wrapper({ children }: IWrapperProps) {
  return (
    <Container fluid className="gx-0 text-dark">
      <Row className="gx-0 h-100">
        <Col xs={12} lg={3} xxl={2} className="text-gray">
          <Menu />
        </Col>
        <Col
          lg={9}
          xxl={10}
          xs={12}
          className={`bg-light overflow-auto scroll-none mx-auto min-vh-100`}
        >
          <div className="container-paddings false scroll-none pb-4 pt-5 py-md-5">
            {children}
          </div>
        </Col>
      </Row>
    </Container>
  );
}
